import React, { useState, useEffect } from "react";
import SvgLogo from "../assets/svg/logo.svg";
export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    // Toggle body class for preventing scroll
    if (!isMobileMenuOpen) {
      document.body.classList.add("release");
      document.documentElement.classList.add("htmlrelease");
    } else {
      document.body.classList.remove("release");
      document.documentElement.classList.remove("htmlrelease");
    }
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    document.body.classList.remove("release");
    document.documentElement.classList.remove("htmlrelease");
  };

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (
        isMobileMenuOpen &&
        !target.closest(".MobileBt") &&
        !target.closest(".MobilMenu")
      ) {
        closeMobileMenu();
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  return (
    <div className="header animate">
      {/* <!--topRow--> */}
      <div className="container-fluid animate topRow">
        <div className="container-fluid container">
          <div className="row end-xs">
            <div className="col-xs">
              {/* <!--menu--> */}
              <div className="topMenu">
                <a href="/kvkk" title="KVKK">
                  KVKK
                </a>
                <a href="/iletisim" title="İletişim">
                  İletişim
                </a>
              </div>
              {/* <!--/menu--> */}
              {/* <!--social--> */}

              {/* <!--/social--> */}
            </div>
          </div>
        </div>
      </div>
      {/* <!--/topRow--> */}
      {/* <!--menuRow--> */}
      <div className="container-fluid animate menuRow">
        <div className="container-fluid container">
          <div className="row">
            <div className="col-xs">
              {/* <!--logo--> */}
              <div
                className="logo"
                onClick={() => (window.location.href = "/")}
              >
                <a href="/" title="SHELL Fleet Solutions"></a>
                <span className="logo-text">Shell Fleet Solutions</span>
                {/* <!--alt sayfalarda aşağıdaki gibi kullan--> */}
                {/* <!--<a href="#" title="SHELL Premium Reseller">SHELL Premium Reseller</a>--> */}
              </div>
              {/* <!--//logo--> */}
              {/* <!--menu--> */}
              <ul className="menu">
                <li>
                  <a
                    href="/urunler/shell-tasit-tanima-sistemi"
                    title="SHELL TAŞIT TANIMA"
                  >
                    SHELL TAŞIT TANIMA
                  </a>
                </li>
                <li>
                  <a href="/urunler" title="ÜRÜNLER">
                    ÜRÜNLER
                  </a>
                </li>
                <li>
                  <a href="/nasil-calisir" title="NASIL ÇALIŞIR">
                    NASIL ÇALIŞIR
                  </a>
                </li>
                <li>
                  <a href="/avantajlar" title="AVANTAJLAR">
                    AVANTAJLAR
                  </a>
                </li>
                <div className="headerButtons">
                  <li>
                    <a
                      href="/hemen-basvur"
                      className="application"
                      title="HEMEN BAŞVUR"
                    >
                      HEMEN BAŞVUR
                    </a>
                  </li>
                  <li>
                    <a
                      href="/portal/utts-montaj-basvuru"
                      className="login"
                      rel="nofollow"
                      title="UTTS MONTAJ BASVUR"
                    >
                      UTTS MONTAJ BAŞVUR
                    </a>
                  </li>
                </div>
              </ul>
              {/** /menu */}
              {/** Mobile */}
              <div
                className={`MobileBt ${isMobileMenuOpen ? "push" : ""}`}
                onClick={toggleMobileMenu}
              >
                <div>
                  <span></span>
                </div>
              </div>
              {/** Mobile */}
            </div>
          </div>
        </div>
      </div>
      {/** /menuRow */}
      {/** MobilMenu */}
      <div className={`MobilMenu ${isMobileMenuOpen ? "OpenMenu" : ""}`}>
        <div className="container-fluid WhiteRow">
          <div className="container-fluid container">
            <ul className="navMenu">
              <li>
                <a
                  href="/urunler/shell-tasit-tanima-sistemi"
                  title="SHELL TAŞIT TANIMA"
                  onClick={closeMobileMenu}
                >
                  SHELL TAŞIT TANIMA
                </a>
              </li>
              <li>
                <a href="/urunler" title="ÜRÜNLER" onClick={closeMobileMenu}>
                  ÜRÜNLER
                </a>
              </li>
              <li>
                <a
                  href="/nasil-calisir"
                  title="NASIL ÇALIŞIR"
                  onClick={closeMobileMenu}
                >
                  NASIL ÇALIŞIR
                </a>
              </li>
              <li>
                <a
                  href="/avantajlar"
                  title="AVANTAJLAR"
                  onClick={closeMobileMenu}
                >
                  AVANTAJLAR
                </a>
              </li>
              <li>
                <a
                  href="/hemen-basvur"
                  className="application"
                  title="HEMEN BAŞVUR"
                  onClick={closeMobileMenu}
                >
                  HEMEN BAŞVUR
                </a>
              </li>
              <li>
                <a
                  href="/portal/utts-montaj-basvuru"
                  className="login"
                  target="_blank"
                  rel="nofollow"
                  title="UTTS MONTAJ BASVUR"
                  onClick={closeMobileMenu}
                >
                  UTTS MONTAJ BAŞVUR
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="container-fluid greyRow">
          <div className="container-fluid container submenu">
            <a href="/kvkk" title="KVKK" onClick={closeMobileMenu}>
              KVKK
            </a>
            <a href="/iletisim" title="İletişim" onClick={closeMobileMenu}>
              İletişim
            </a>
          </div>
          <div className="container-fluid container social">
            {/* Social media links can be added here if needed */}
          </div>
        </div>
      </div>
      {/** MobilMenu */}
    </div>
  );
}
